export const searchApi = [
  "/shop/detail/product/queryList",
  "/creator/queryList",
  "/shop/queryList",
  "/product/queryList",
  "/creator/detail/live/queryList",
  "/creator/detail/product/queryList",
  "/creator/detail/video/queryList",
  "/creator/detail/shop/queryList",
  "/product/detail/creator/queryList",
  "/product/detail/video/queryList",
  "/product/detail/live/queryList",
  "/homepage/hot/video/queryList",
  "/shop/queryList",
  "/creator/queryList",
  "/homepage/hot/live/queryList",
  "/livestream/detail/product/queryList",
  "/creator/detail/live/queryList",
  "/creator/detail/product/queryList",
  "/creator/detail/shop/queryList",
  "/creator/detail/live/queryList",
  "/video/queryList",
  "/product/queryList",
  "/livestream/queryList",
  "/video/queryList",
  "/product/detail/creator/queryList",
  "/product/detail/live/queryList",
  "/product/detail/video/queryList",
  "/livestream/detail/product/queryList",
  "/creator/detail/video/queryList",
  "/homepage/hot/video/queryList",
  "/home/focus/creator/queryList",
  "/home/focus/shop/queryList",
];
